export const RATMEN_SIZE_FOR_ADDITIONAL_SUPPLY = 1;

export const RATMEN_MELEE_COMBAT_BONUS_PER_ALLY = 1;

export const RATMEN_D6_SAME_TYPE_UNIT_LIMIT = 4;
